import React, { useState, useContext } from 'react';
import { DropdownButton } from 'react-bootstrap';
import { getListOfTask } from './view_list_logic';
import LoaderContext from '../layout/shared/loader_context';

export const ViewDetailSelect = (props) => {
  const Loader = useContext(LoaderContext);
  const [taskDetails, setTaskDetails] = useState([]);

  const getTasks = async () => {
    await getListOfTask(props, setTaskDetails, Loader);
  };

  return (
    <DropdownButton
      id="dropdown-basic-button"
      title="Ver Detalle"
      variant={'secondary'}
      onClick={() => getTasks()}
    >
      {taskDetails}
    </DropdownButton>
  );
};

export default ViewDetailSelect;
